import { freeze } from '@rehaje/shared'

export const defaultLocales = freeze({
  data: '数据',
  error: '错误信息',
  id: '唯一标识',
  loading: '加载中',
  props: '属性',
  propsScript: '执行脚本',
  reset: '重置',
  trigger: '执行',
  triggerParams: '执行入参',
  type: '类型'
})
